import pick from "lodash/pick";

import { object, boolean, string } from "../../../../util/yup";

export const buildValidationSchema = (fields) =>
  object().shape(
    pick(
      {
        organization_name: string().required("Cannot be blank"),
        email: string()
          .required("Cannot be blank")
          .email("Must be a valid email address")
          .notPublicEmail(),
        password: string()
          .required("Cannot be blank")
          .min(8, "Password must have minimum 8 characters")
          .max(128, "Must be at most 128 characters"),
        agrees_to_terms: boolean().oneOf(
          [true],
          "Users must accept online terms"
        ),
        agrees_to_temp_terms: boolean().oneOf(
          [true],
          "Users must accept online terms"
        ),
      },
      fields
    )
  );

export const bundleFormContext = (props) =>
  pick(props, [
    "values",
    "errors",
    "touched",
    "handleChange",
    "handleBlur",
    "handleSubmit",
    "isSubmitting",
    "setFieldTouched",
    "setFieldValue",
    "status",
  ]);

export const handleSubmit = (values, { props, setSubmitting }) => {
  const { createRecruiter } = props;
  const data = pick(values, [
    "organization_name",
    "email",
    "password",
    "agrees_to_terms",
    "legacy_invitation_id",
    "solicited_employer_profile_id",
    "terms_type",
  ]);

  createRecruiter({
    ...data,
    stripe_agrees_to_terms: values.agrees_to_terms,
  }).catch(() => {
    setSubmitting(false);
  });
};
